import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PlanPriceModel } from 'src/app/core/model/object/shop-model';

@Injectable()
export class ShopShared {
  constructor() {}

  private discountPrices: Array<PlanPriceModel>;
  private discountCode: string;
  private _reward: number;

  private dismissPopupObs = new BehaviorSubject<boolean>(false);
  dismissPopupObs$ = this.dismissPopupObs.asObservable();

  private confirmPopupObs = new BehaviorSubject<boolean>(false);
  confirmPopupObs$ = this.confirmPopupObs.asObservable();

  private hasDiscountObs = new BehaviorSubject<boolean>(false);
  hasDiscountObs$ = this.hasDiscountObs.asObservable();

  private hasRewardObs = new BehaviorSubject<boolean>(false);
  hasRewardObs$ = this.hasRewardObs.asObservable();

  dismissPopup() {
    this.dismissPopupObs.next(true);
    this.dismissPopupObs.next(false);
  }

  confirmPopup() {
    this.confirmPopupObs.next(true);
    this.confirmPopupObs.next(false);
  }

  hasDiscount(has: boolean) {
    this.hasDiscountObs.next(has);
  }

  hasReward() {
    this.hasRewardObs.next(true);
    this.hasRewardObs.next(false);
  }

  setDiscountValues(d: Array<PlanPriceModel>, code: string) {
    this.discountPrices = d;
    this.discountCode = code;
  }

  getDiscountPrices() {
    return this.discountPrices;
  }

  getDiscountCode() {
    return this.discountCode;
  }

  public get reward(): number {
    return this._reward;
  }
  public set reward(value: number) {
    this._reward = value;
  }
}
